module.exports = __webpack_public_path__ + "static/img/img2.b9568f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img2.jpg
// module id = 31ww
// module chunks = 1